// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3uDo6","productName":"Table_productName__SKkO2"};